<section class="flex flex-col">
  <div class="mx-auto w-full max-w-[90rem] p-5 md:px-8">
    <div class="flex flex-col gap-4">
      <div
        class="flex flex-row flex-wrap items-center justify-center gap-4 sm:justify-between"
      >
        <h1 class="flex justify-between">Metric Details</h1>

        <!-- Toggle pill -->
        <div class="flex items-center justify-center lg:ml-2">
          <app-toggle
            [disabled]="loading"
            [(ngModel)]="showMockData"
            (ngModelChange)="toggleMockData($event)"
            [label]="
              showMockData ? 'Switch to Real Data' : 'Switch to Sample Data'
            "
            size="md"
            color="primary"
          >
          </app-toggle>
        </div>
      </div>
      <div class="mb-4 flex flex-grow items-center justify-between gap-4">
        <div class="w-full">
          <app-sorting-dropdown
            (selectedOptionChange)="onSortingChange($event)"
          />
        </div>
        <div class="w-full">
          <app-select-dimension-dropdown
            (selectedOptionChange)="onDimensionChange($event)"
          />
        </div>
        <div class="w-full">
          <app-analytics-time-selector
            (selectedOptionChange)="onChildSelectionChange($event)"
            label="Activation Time"
          />
        </div>
      </div>
    </div>

    @if (selectedDimension === 'connection') {
      <div class="chart-filters mb-px flex justify-end">
        <div class="dimension-filter-box">
          <div>
            <mat-button-toggle-group
              name="metricType"
              aria-label="metrics"
              [(ngModel)]="metricType"
              (change)="onMetricChange()"
              class="filter-buttons-box"
            >
              <mat-button-toggle value="data_usage">Usage</mat-button-toggle>
              <mat-button-toggle value="jitter">Jitter</mat-button-toggle>
              <mat-button-toggle value="latency">Latency</mat-button-toggle>
              <mat-button-toggle value="packet_loss"
                >Packet Loss</mat-button-toggle
              >
            </mat-button-toggle-group>
          </div>
        </div>
      </div>
    }

    @if (loading) {
      <div
        class="loading-indicator flex flex-col items-center py-10 text-center text-white"
      >
        <mat-spinner [diameter]="50"></mat-spinner>
        <p class="mt-4">Loading metrics data...</p>
      </div>
    } @else if (isNoContent) {
      <div class="no-content-message py-10 text-center text-white">
        <h2 class="text-lg font-semibold">
          No metrics data available for the selected criteria.
        </h2>
        <p>Please adjust your filters or dimensions.</p>
      </div>
    } @else {
      <div class="grid grid-cols-1 gap-5 md:grid-cols-2">
        <div class="w-full">
          <app-analytics-widget
            [isNoContent]="isNoContent"
            [loading]="loading"
            class="h-full w-full"
          >
            <app-horizontal-bar-graph
              [data]="sortedMetricsData"
              [categories]="metricCategories"
              [chartName]="selectedMetricLabel"
              (changeDevice)="onChangeDevice($event)"
            />
          </app-analytics-widget>
        </div>
        <div class="w-full">
          <app-analytics-widget
            [isNoContent]="isNoContent"
            [loading]="loading"
            class="h-full w-full"
          >
            <app-trend-histogram
              [categories]="historicalCategories"
              [chartName]="selectedDeviceChartLabel"
            />
          </app-analytics-widget>
        </div>
      </div>
    }

    <div class="scrollbar-thin mt-4 w-full overflow-x-auto">
      <app-metric-details
        [dataSource]="unmTableData"
        [loading]="tableLoading"
        [isNoContent]="isNoTableContent"
        [tableDimension]="selectedDimension"
        class="min-w-[40rem] md:min-w-0"
      />
    </div>
  </div>
</section>
